import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {
  Col,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  FormGroup,
  Form,
  Card,
  ModalFooter,
} from "reactstrap";
import Dropzone from "react-dropzone";

import "flatpickr/dist/themes/material_blue.css";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { showInfoMessage } from "../../../../helpers/utils";
import InvoiceTemplate3 from '../../Invoices/InvoicesProfile/components/template3';
import InvoiceTemplate2 from '../../Invoices/InvoicesProfile/components/template2';
import InvoiceTemplate1 from '../../Invoices/InvoicesProfile/components/template1';
import CustomSelect from '../../../../components/Common/CustomSelect';
import { Link } from "react-router-dom";

const CHANGE_WORDS = [
  {
    label: 'Word: Invoice',
    name: 'invoice',
    placeholder: 'Current: Invoice...',
  },
  {
    label: 'Word: DATE',
    name: 'date',
    placeholder: 'Current: DATE...',
  }, {
    label: 'Word: TO',
    name: 'to',
    placeholder: 'Current: TO...',
  }, {
    label: 'Word: Billing information',
    name: 'bill_info',
    placeholder: 'Current: Billing information...',
  }, {
    label: 'Word: Type',
    name: 'type',
    placeholder: 'Current: Type...',
  }, {
    label: 'Word: Period',
    name: 'period',
    placeholder: 'Current: Period...',
  }, {
    label: 'Word: Amount',
    name: 'amount',
    placeholder: 'Current: Amount...',
  }, {
    label: 'Word: Grand total',
    name: 'grand_total',
    placeholder: 'Current: Grand total...',
  }, {
    label: 'Word: Director',
    name: 'director',
    placeholder: 'Current: Director...',
  },
]

const TEMPLATES = [
  {
    label: 'Template 1',
    value: '14',
  },
  {
    label: 'Template 2',
    value: '15',
  },
  {
    label: 'Template 3',
    value: '16',
  },
]

const ModalInvoiceTemplates = props => {
  const {
    isOpen,
    toggle,
    addInvoiceTemplate,
    updateInvoiceTemplate,
    editData,
  } = props;

  const [selectedFiles, setSelectedFiles] = React.useState([]);
  const [isVoucherCurrency, setIsVoucherCurrency] = React.useState(false);
  const [invoiceTemplate, setInvoiceTemplate] = React.useState(TEMPLATES[0]);
  const [valuesTemplate, setValuesTemplate] = React.useState({})

  let defDataForTemplates = {
    "demo": true,
    "classification": "CUSTOM",
    "notCustomColls": [
      {
        "Header": isVoucherCurrency ? "Опис" : "Type",
        "accessor": "type",
        "style": {
          "textAlign": "center",
          "width": "auto",
          "verticalAlign": "middle"
        }
      },
      {
        "Header": isVoucherCurrency ? "Кількість годин" : "Period",
        "accessor": "period",
        "style": {
          "textAlign": "center",
          "width": "30%",
          "verticalAlign": "middle"
        }
      },
      {
        "Header": isVoucherCurrency ? "Сума" : "Amount",
        "accessor": "total",
        "style": {
          "textAlign": "center",
          "width": "30%",
          "verticalAlign": "middle"
        }
      }
    ],
    "ClientColls": [
      {
        "Header": isVoucherCurrency ? "Опис" : "Type",
        "accessor": "title",
        "style": {
          "textAlign": "center",
          "width": "auto",
          "verticalAlign": "middle"
        }
      },
      {
        "Header": isVoucherCurrency ? "Кількість годин" : "Period",
        "style": {
          "textAlign": "center",
          "width": "30%",
          "verticalAlign": "middle"
        }
      },
      {
        "Header": isVoucherCurrency ? "Сума" : "Amount",
        "accessor": "custom_unit_price",
        "style": {
          "textAlign": "center",
          "width": "30%",
          "verticalAlign": "middle"
        }
      }
    ],
    "total_in_custom_currency": isVoucherCurrency ? "100 UAH" : "100 USD",
    "invoiceData": {
      "id": 318,
      "items": [
        {
          "id": 711,
          "title": isVoucherCurrency ? "Надані послуги. Без ПДВ" : "Services provided. Excluding VAT",
          "quantity": "1.000",
          "unit": "PIECES",
          "unit_price": "100",
          "custom_unit_price": isVoucherCurrency ? "100 UAH" : "100 USD",
          "discount": "0.0",
          "tax_rate": null,
          "tag": null,
          "weight": 0,
          "date_from": "2024-01-01",
          "date_to": "2024-01-31",
          "created": "2024-02-13T11:02:59.374629Z",
          "modified": "2024-02-13T11:02:59.374653Z",
          "invoice": 318
        }
      ],
      "total_in_custom_currency": isVoucherCurrency ? "100 UAH" : "100 USD",
      "type": "INVOICE",
      "classification": "CUSTOM",
      "sequence": 25,
      "number": "1",
      "status": "NEW",
      "language": "ru",
      "date_issue": "2024-02-13",
      "date_tax_point": "2024-02-13",
      "date_due": "2024-02-29",
      "currency": isVoucherCurrency ? "UAH" : "USD",
      "currency_value": "37.87",
      "total_in_the_selected_currency": "100",
      "credit": "0.00",
      "payment_method": "BANK_TRANSFER",
      "bank_name": isVoucherCurrency ? "АТ ВТ \"БАНК\"" : "AT BT \"BANK NAME\"",
      "bank_street": isVoucherCurrency ? "Україна, 00000, м. Київ, Вулиця" : "Ukraine, 00000, Kyiv, Lights Street, 1D",
      "bank_account_number": "UA000000000000000000000000000",
      "supplier_bank_correspondents": "[]",
      "supplier_name": isVoucherCurrency ? "ФОП Назва Постачальника" : "FOP Supplier Name",
      "supplier_street": isVoucherCurrency ? "Україна, 11111, м. Київ, Вулиця Постачальник, 1Д" : "Ukraine, 11111, Kyiv, Supplier Street, 1A",
      "supplier_signer": isVoucherCurrency ? "Постачальник Ім\'я Підписанта" : "Supplier Signer Name",
      "customer_name": isVoucherCurrency ? "АТ \"БАНК\"" : "AT \"BANK\"",
      "customer_street": isVoucherCurrency ? "44444, м. Київ, Вулиця, 1А" : "44444, Kyiv, Avrage Street, 54/19",
      "delivery_method": "PERSONAL_PICKUP",
      "payment_description": isVoucherCurrency ? "Надані послуги" : "Services provided",
      "period": "2024-01-01 - 2024-01-31",
      "date_from": "2024-01-01",
      "date_to": "2024-01-31",
    },
    "base64Image": "",
    "langUA": isVoucherCurrency
  }

  React.useEffect(() => {
    if (editData !== null && isOpen) {
      setValuesTemplate(editData.data)
      let idx = TEMPLATES.findIndex((i) => i.value == editData.data.template);
      if (idx >= 0) {
        setInvoiceTemplate(TEMPLATES[idx])
      }
      // convertFromURLToFile(editData.file);
    } else {
      setSelectedFiles([]);
    }
  }, [isOpen]);

  const convertFromURLToFile = url => {
    fetch(url.replace("http", "https"))
      .then(res => res.blob())
      .then(blob => {
        let file = new File([blob], url.split("/").pop(), {
          type: blob.type,
          url: URL.createObjectURL(blob),
          formattedSize: formatBytes(blob.size),
        });
        let converted = Object.assign(file, {
          url: URL.createObjectURL(file),
          formattedSize: formatBytes(file.size),
        });
        setSelectedFiles([converted]);
      });
  };

  const handleValidOrderSubmit = (e, errors, params) => {
    // && selectedFiles[0] !== undefined
    if (errors?.length === 0) {
      let data = new FormData();
      data.append("name", params.name);

      let obj = {};

      for (let [k, val] of Object.entries(params)) {
        if (k !== 'name') {
          obj[k] = val;
        }
      }

      if (Object.keys(obj).length > 0) {
        obj['template'] = params.template.value;
        data.append("data", JSON.stringify(obj));
      }
      // data.append("file", selectedFiles[0]);
      if (editData !== null) {
        updateInvoiceTemplate(editData.id, data);
        toggle();
      } else {
        addInvoiceTemplate(data);
        toggle();
      }
    }
    //  else {
    //   showInfoMessage("File is required");
    // }
  };

  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  const handleAcceptedFiles = files => {
    let file_type = files[0].path.split(".").pop();
    let file_types = ["docx"];
    if (file_types.indexOf(file_type) >= 0) {
      files.map(file =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
          formattedSize: formatBytes(file.size),
        })
      );
      setSelectedFiles(files);
    } else {
      showInfoMessage("Unavailable format, add file with .docx format!");
    }
  };

  const handleChange = (a) => {
    const { name, value } = a.target
    let current = { ...valuesTemplate };
    current[name] = value;
    setValuesTemplate(current);
  }

  return (
    <Modal isOpen={isOpen} autoFocus={true} size={'lg'} centered={true} toggle={toggle}>
      <AvForm className="needs-validation" onSubmit={handleValidOrderSubmit}>
        <div className="modal-header">
          <h4 className="modal-title mt-0" id="myModalLabel">
            {editData !== null ? "Edit" : "Add"} invoice template
          </h4>
          <button
            type="button"
            onClick={toggle}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <ModalBody>
          <Row form>
            <Col className="col-4">
              <FormGroup className="mb-3">
                <Label>Name</Label>
                <AvField
                  name="name"
                  type="text"
                  placeholder="Template name..."
                  errorMessage="This value is required."
                  value={editData?.name || ""}
                  validate={{
                    required: { value: true },
                    maxLength: {
                      value: 255,
                      errorMessage: "Max 255 characters.",
                    },
                  }}
                />
              </FormGroup>
              {/* <FormGroup className="mb-3">
                <Dropzone
                  onDrop={acceptedFiles => handleAcceptedFiles(acceptedFiles)}
                >
                  {({ getRootProps, getInputProps }) => (
                    <StyledDropzone className="dropzone">
                      <div
                        className="dz-message needsclick"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        <div className="mb-3">
                          <i className="display-4 text-muted bx bxs-cloud-upload" />
                        </div>
                        <h4>Drop files here or click to upload.</h4>
                      </div>
                    </StyledDropzone>
                  )}
                </Dropzone>
                <div className="dropzone-previews mt-3" id="file-previews">
                  {selectedFiles.map((f, i) => {
                    return (
                      <Card
                        className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                        key={i + "-file"}
                      >
                        <div className="p-2">
                          <Row className="align-items-center">
                            <Col className="col-auto ms-2">
                              <i className="mdi mdi-file-document font-size-22 align-middle text-primary " />
                            </Col>
                            <Col>
                              <Link
                                to="#"
                                className="text-muted font-weight-bold"
                              >
                                {f.name}
                              </Link>
                              <p className="mb-0">
                                <strong>{f.formattedSize}</strong>
                              </p>
                            </Col>
                            {editData?.file && (
                              <Col className="col-auto me-2">
                                <a
                                  href={
                                    editData?.file.replace("http", "https") ||
                                    ""
                                  }
                                  download
                                >
                                  <StyledDownload className="mdi  mdi-download font-size-22 align-middle text-primary " />
                                </a>
                              </Col>
                            )}
                          </Row>
                        </div>
                      </Card>
                    );
                  })}
                </div>
              </FormGroup> */}
            </Col>
          </Row>
          <Row className="d-flex justify-content-center text-center mt-4">
            <b><span>Word substitution for template</span></b>
          </Row>
          <hr />
          <Row>
            {CHANGE_WORDS.map((i, k) => (
              <Col lg="4" key={k}>
                <FormGroup className="mb-3">
                  <Label>{i.label}</Label>
                  <AvField
                    name={i.name}
                    type="text"
                    placeholder={i.placeholder}
                    value={editData.data[i.name] || ""}
                    onChange={handleChange}
                    validate={{
                      // required: { value: true },
                      maxLength: {
                        value: 255,
                        errorMessage: "Max 255 characters.",
                      },
                    }}
                  />
                </FormGroup>
              </Col>
            ))}
          </Row>
          <Row>
            <Col lg={12} xl={6} className="mb-3">
              <Label htmlFor="">Invoice template:</Label>
              <CustomSelect
                name="template"
                options={TEMPLATES}
                placeholder="Select invoice template..."
                defaultValue={invoiceTemplate}
                onChange={setInvoiceTemplate}
                classNamePrefix="select2-selection"
              />
            </Col>
            <Col sm={12}>
              {invoiceTemplate?.value == "14" && (
                <TemplateDiv>

                  <InvoiceTemplate1
                    {...defDataForTemplates}
                    valuesTemplate={valuesTemplate}
                    demo
                  />
                </TemplateDiv>
              )}
              {invoiceTemplate?.value == "15" && (
                <TemplateDiv>

                  <InvoiceTemplate2
                    {...defDataForTemplates}
                    valuesTemplate={valuesTemplate}
                    demo
                  />
                </TemplateDiv>
              )}
              {invoiceTemplate?.value == "16" && (
                <TemplateDiv>
                  <InvoiceTemplate3
                    {...defDataForTemplates}
                    valuesTemplate={valuesTemplate}
                    demo
                  />
                </TemplateDiv>
              )}
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="pe-0">
          <Row>
            <Col>
              <div className="text-end">
                <button
                  onClick={e => {
                    e.preventDefault();
                    toggle();
                  }}
                  className="btn btn-primary save-user"
                >
                  Close
                </button>
                {props.permissions?.["change_invoicetemplatemodel"] && (
                  <button
                    type="submit"
                    className="btn btn-success save-user ms-2"
                  >
                    Save changes
                  </button>
                )}
              </div>
            </Col>
          </Row>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

const TemplateDiv = styled.div`
  border: 1px solid rgba(102, 102, 130, 0.4);
  border-radius: 5px;
    padding: 20px;
`;

const StyledDropzone = styled.div`
  min-height: 130px;
  .dropzone {
    min-height: 130px !important;
  }


`;

const StyledDownload = styled.i`
  opacity: 0.8;
  transition: 0.5s;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
`;

ModalInvoiceTemplates.propTypes = {
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  data: PropTypes.any.isRequired,
  addInvoiceTemplate: PropTypes.func.isRequired,
  updateInvoiceTemplate: PropTypes.func.isRequired,
  permissions: PropTypes.any.isRequired,
  editData: PropTypes.any,
};

export default ModalInvoiceTemplates;
